module.exports = __webpack_public_path__ + "static/grafika9-8671c5a45b6f79b570b55f94ea662a7f.png";